import { render, staticRenderFns } from "./TabYearMonth.vue?vue&type=template&id=16916774&scoped=true"
import script from "./TabYearMonth.vue?vue&type=script&lang=js"
export * from "./TabYearMonth.vue?vue&type=script&lang=js"
import style0 from "./TabYearMonth.vue?vue&type=style&index=0&id=16916774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16916774",
  null
  
)

export default component.exports